// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/login_background_image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.auth-loading {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  color: #1f2937;
  font-size: 1rem;
}

.login-page {
  display: flex;
  height: 100vh;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.sign-in-card {
  display: flex;
  width: 42vw;
  min-width: 500px;
  height: 100vh;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(15, 23, 42, 0.08);
  background-color: #ffffff;
  box-shadow: 8px 0 28px rgba(15, 23, 42, 0.06);
}

.sign-in-wrapper {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  max-width: 520px;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 2.25rem;
}

.sign-in-header {
  margin-bottom: 1.5rem;
  text-align: center;
}

.sign-in-title {
  margin: 0 0 0.55rem !important;
  color: #1f2937;
  font-size: 2.1rem;
  font-weight: 500;
  letter-spacing: -0.03em;
}

.sign-in-subtitle {
  margin: 0 !important;
  color: #52627a;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.sign-in-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 1.05rem;
}

.registration-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  margin: 0.2rem 0 0.4rem;
  color: #111827;
  font-size: 0.95rem;
}

.registration-links a,
.registration-links a:link,
.registration-links a:visited {
  color: #0073ab;
  font-weight: 500;
  text-decoration: underline;
}

.registration-links a:hover,
.registration-links a:focus {
  color: #005f8e;
}

.access-instructions {
  box-sizing: border-box;
  width: 100%;
  max-width: 460px;
  padding: 1rem 1.1rem;
  border: 1px solid #d6e2ea;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.07);
  color: #1f2937;
  text-align: left;
}

.access-header {
  margin-bottom: 0.75rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #edf2f7;
}

.access-title {
  margin: 0 0 0.2rem;
  color: #111827;
  font-size: 0.9rem;
  font-weight: 700;
}

.access-title-note {
  color: #5f6b7a;
  font-size: 0.78rem;
  font-weight: 500;
}

.access-subtitle {
  margin: 0;
  color: #5f6b7a;
  font-size: 0.74rem;
  font-weight: 500;
  line-height: 1.35;
}

.access-card-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.access-option-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  padding: 0.55rem 0.65rem;
  border: 1px solid #e4edf3;
  border-radius: 8px;
  background-color: #f8fbfd;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease;
}

.access-option-card:hover {
  border-color: #b8d8e8;
  background-color: #ffffff;
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.05);
}

.access-option-content {
  flex: 1 1;
  min-width: 0;
}

.access-option-title {
  margin: 0;
  color: #1f2937;
  font-size: 0.76rem;
  font-weight: 700;
  overflow-wrap: break-word;
}

.access-option-description {
  margin: 0.15rem 0 0;
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 500;
  line-height: 1.35;
}

.access-option-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.55rem;
}

/*
  Request-access button.

  The normal, visited and link states are explicitly styled.
  This prevents global anchor styles from making the button
  transparent before hover.
*/
.access-action-link,
.access-action-link:link,
.access-action-link:visited {
  display: inline-flex !important;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.65rem;
  border: 1px solid #0073ab !important;
  border-radius: 999px;
  background: #0073ab !important;
  background-color: #0073ab !important;
  color: #ffffff !important;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  opacity: 1 !important;
  text-align: center;
  text-decoration: none !important;
  visibility: visible !important;
  white-space: nowrap;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.1s ease;
}

.access-action-link:hover,
.access-action-link:focus,
.access-action-link:focus-visible {
  border-color: #005f8e !important;
  background: #005f8e !important;
  background-color: #005f8e !important;
  color: #ffffff !important;
  text-decoration: none !important;
}

.access-action-link:focus-visible {
  outline: 3px solid rgba(0, 115, 171, 0.25);
  outline-offset: 2px;
}

.access-action-link:active {
  border-color: #004f77 !important;
  background: #004f77 !important;
  background-color: #004f77 !important;
  color: #ffffff !important;
  transform: translateY(1px);
}

.access-guide-link,
.access-guide-link:link,
.access-guide-link:visited {
  padding: 0;
  border: none;
  background: transparent;
  color: #0073ab !important;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.7rem;
  font-weight: 700;
  text-decoration: underline;
  white-space: nowrap;
}

.access-guide-link:hover,
.access-guide-link:focus {
  color: #005f8e !important;
}

.access-note {
  margin: 0.65rem 0 0;
  color: #6b7280;
  font-size: 0.68rem;
  font-weight: 500;
  line-height: 1.35;
}

.access-request-footer {
  margin-top: 0.75rem;
  padding-top: 0.7rem;
  border-top: 1px solid #edf2f7;
  text-align: center;
}

.access-request-footer .access-guide-link {
  font-size: 0.62rem;
}

.access-request-footer .access-note {
  margin: 0 0 0.35rem;
}

.sign-in-button {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 115, 171, 0.22);
  color: #ffffff;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
  transition: all 0.25s ease;
}

.sign-in-button:hover {
  box-shadow: 0 8px 30px rgba(0, 115, 171, 0.3);
  transform: translateY(-2px);
}

.sign-in-button:active {
  transform: translateY(-1px);
}

.sign-in-footer {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  text-align: center;
}

.footer-text {
  margin: 0;
  color: #718096;
  font-size: 0.9rem;
  line-height: 1.6;
}

@media (max-width: 1024px) {
  .sign-in-card {
    width: 46vw;
    min-width: 480px;
  }

  .sign-in-wrapper {
    max-width: 500px;
    padding: 2.25rem 2rem;
  }

  .access-instructions {
    max-width: 440px;
  }

  .access-option-title {
    font-size: 0.74rem;
  }

  .access-action-link,
  .access-action-link:link,
  .access-action-link:visited,
  .access-guide-link,
  .access-guide-link:link,
  .access-guide-link:visited {
    font-size: 0.68rem;
  }
}

@media (max-width: 768px) {
  .login-page {
    box-sizing: border-box;
    justify-content: center;
    padding: 1rem;
    background-color: #ffffff;
    background-image: none;
  }

  .sign-in-card {
    width: 100%;
    min-width: auto;
    min-height: auto;
    height: auto;
    border-right: none;
    border-radius: 1rem;
    box-shadow: none;
  }

  .sign-in-wrapper {
    max-width: 520px;
    padding: 2rem 1rem;
  }

  .sign-in-title {
    font-size: 1.85rem;
  }

  .access-instructions {
    max-width: 100%;
  }
}

@media (max-width: 520px) {
  .access-option-card {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.45rem;
  }

  .access-option-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 480px) {
  .sign-in-wrapper {
    padding: 1.5rem 0.75rem;
  }

  .sign-in-title {
    font-size: 1.6rem;
  }

  .sign-in-subtitle {
    font-size: 0.9rem;
  }

  .registration-links {
    flex-direction: column;
    gap: 0.25rem;
  }

  .access-instructions {
    padding: 0.95rem;
  }

  .access-option-title {
    font-size: 0.74rem;
  }

  .access-option-description {
    font-size: 0.66rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/authentication.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,UAAU;EACV,yDAA6D;EAC7D,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB;;;wBAGsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;;;CAMC;AACD;;;EAGE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,oBAAoB;EACpB,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB;;;uBAGqB;AACvB;;AAEA;;;EAGE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;;;IAME,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".app-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.auth-loading {\n  display: flex;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n  color: #1f2937;\n  font-size: 1rem;\n}\n\n.login-page {\n  display: flex;\n  height: 100vh;\n  align-items: stretch;\n  justify-content: flex-start;\n  padding: 0;\n  background-image: url(\"../public/login_background_image.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.sign-in-card {\n  display: flex;\n  width: 42vw;\n  min-width: 500px;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n  border-right: 1px solid rgba(15, 23, 42, 0.08);\n  background-color: #ffffff;\n  box-shadow: 8px 0 28px rgba(15, 23, 42, 0.06);\n}\n\n.sign-in-wrapper {\n  display: flex;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 520px;\n  flex-direction: column;\n  align-items: center;\n  padding: 2.5rem 2.25rem;\n}\n\n.sign-in-header {\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.sign-in-title {\n  margin: 0 0 0.55rem !important;\n  color: #1f2937;\n  font-size: 2.1rem;\n  font-weight: 500;\n  letter-spacing: -0.03em;\n}\n\n.sign-in-subtitle {\n  margin: 0 !important;\n  color: #52627a;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.sign-in-content {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.05rem;\n}\n\n.registration-links {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  margin: 0.2rem 0 0.4rem;\n  color: #111827;\n  font-size: 0.95rem;\n}\n\n.registration-links a,\n.registration-links a:link,\n.registration-links a:visited {\n  color: #0073ab;\n  font-weight: 500;\n  text-decoration: underline;\n}\n\n.registration-links a:hover,\n.registration-links a:focus {\n  color: #005f8e;\n}\n\n.access-instructions {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 460px;\n  padding: 1rem 1.1rem;\n  border: 1px solid #d6e2ea;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.07);\n  color: #1f2937;\n  text-align: left;\n}\n\n.access-header {\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.7rem;\n  border-bottom: 1px solid #edf2f7;\n}\n\n.access-title {\n  margin: 0 0 0.2rem;\n  color: #111827;\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.access-title-note {\n  color: #5f6b7a;\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n\n.access-subtitle {\n  margin: 0;\n  color: #5f6b7a;\n  font-size: 0.74rem;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.access-card-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.access-option-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid #e4edf3;\n  border-radius: 8px;\n  background-color: #f8fbfd;\n  transition:\n    border-color 0.2s ease,\n    background-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.access-option-card:hover {\n  border-color: #b8d8e8;\n  background-color: #ffffff;\n  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.05);\n}\n\n.access-option-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.access-option-title {\n  margin: 0;\n  color: #1f2937;\n  font-size: 0.76rem;\n  font-weight: 700;\n  overflow-wrap: break-word;\n}\n\n.access-option-description {\n  margin: 0.15rem 0 0;\n  color: #64748b;\n  font-size: 0.68rem;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.access-option-actions {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n/*\n  Request-access button.\n\n  The normal, visited and link states are explicitly styled.\n  This prevents global anchor styles from making the button\n  transparent before hover.\n*/\n.access-action-link,\n.access-action-link:link,\n.access-action-link:visited {\n  display: inline-flex !important;\n  min-height: 28px;\n  align-items: center;\n  justify-content: center;\n  padding: 0.35rem 0.65rem;\n  border: 1px solid #0073ab !important;\n  border-radius: 999px;\n  background: #0073ab !important;\n  background-color: #0073ab !important;\n  color: #ffffff !important;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.7rem;\n  font-weight: 700;\n  line-height: 1;\n  opacity: 1 !important;\n  text-align: center;\n  text-decoration: none !important;\n  visibility: visible !important;\n  white-space: nowrap;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    transform 0.1s ease;\n}\n\n.access-action-link:hover,\n.access-action-link:focus,\n.access-action-link:focus-visible {\n  border-color: #005f8e !important;\n  background: #005f8e !important;\n  background-color: #005f8e !important;\n  color: #ffffff !important;\n  text-decoration: none !important;\n}\n\n.access-action-link:focus-visible {\n  outline: 3px solid rgba(0, 115, 171, 0.25);\n  outline-offset: 2px;\n}\n\n.access-action-link:active {\n  border-color: #004f77 !important;\n  background: #004f77 !important;\n  background-color: #004f77 !important;\n  color: #ffffff !important;\n  transform: translateY(1px);\n}\n\n.access-guide-link,\n.access-guide-link:link,\n.access-guide-link:visited {\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #0073ab !important;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-decoration: underline;\n  white-space: nowrap;\n}\n\n.access-guide-link:hover,\n.access-guide-link:focus {\n  color: #005f8e !important;\n}\n\n.access-note {\n  margin: 0.65rem 0 0;\n  color: #6b7280;\n  font-size: 0.68rem;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.access-request-footer {\n  margin-top: 0.75rem;\n  padding-top: 0.7rem;\n  border-top: 1px solid #edf2f7;\n  text-align: center;\n}\n\n.access-request-footer .access-guide-link {\n  font-size: 0.62rem;\n}\n\n.access-request-footer .access-note {\n  margin: 0 0 0.35rem;\n}\n\n.sign-in-button {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 115, 171, 0.22);\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 1.1rem;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: none;\n  transition: all 0.25s ease;\n}\n\n.sign-in-button:hover {\n  box-shadow: 0 8px 30px rgba(0, 115, 171, 0.3);\n  transform: translateY(-2px);\n}\n\n.sign-in-button:active {\n  transform: translateY(-1px);\n}\n\n.sign-in-footer {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  text-align: center;\n}\n\n.footer-text {\n  margin: 0;\n  color: #718096;\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n@media (max-width: 1024px) {\n  .sign-in-card {\n    width: 46vw;\n    min-width: 480px;\n  }\n\n  .sign-in-wrapper {\n    max-width: 500px;\n    padding: 2.25rem 2rem;\n  }\n\n  .access-instructions {\n    max-width: 440px;\n  }\n\n  .access-option-title {\n    font-size: 0.74rem;\n  }\n\n  .access-action-link,\n  .access-action-link:link,\n  .access-action-link:visited,\n  .access-guide-link,\n  .access-guide-link:link,\n  .access-guide-link:visited {\n    font-size: 0.68rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .login-page {\n    box-sizing: border-box;\n    justify-content: center;\n    padding: 1rem;\n    background-color: #ffffff;\n    background-image: none;\n  }\n\n  .sign-in-card {\n    width: 100%;\n    min-width: auto;\n    min-height: auto;\n    height: auto;\n    border-right: none;\n    border-radius: 1rem;\n    box-shadow: none;\n  }\n\n  .sign-in-wrapper {\n    max-width: 520px;\n    padding: 2rem 1rem;\n  }\n\n  .sign-in-title {\n    font-size: 1.85rem;\n  }\n\n  .access-instructions {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 520px) {\n  .access-option-card {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 0.45rem;\n  }\n\n  .access-option-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 480px) {\n  .sign-in-wrapper {\n    padding: 1.5rem 0.75rem;\n  }\n\n  .sign-in-title {\n    font-size: 1.6rem;\n  }\n\n  .sign-in-subtitle {\n    font-size: 0.9rem;\n  }\n\n  .registration-links {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .access-instructions {\n    padding: 0.95rem;\n  }\n\n  .access-option-title {\n    font-size: 0.74rem;\n  }\n\n  .access-option-description {\n    font-size: 0.66rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
